import { render, staticRenderFns } from "./statistics-main-users.vue?vue&type=template&id=bf68af7e"
import script from "./statistics-main-users.vue?vue&type=script&lang=js"
export * from "./statistics-main-users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports